import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { useEffect } from 'react';

export default function Fancybox({ children, delegate = '[data-fancybox]', options = {} }) {
  useEffect(() => {
    const opts = {
      ...options,
      iframe: {
        preload: false,
        css: {
          width: '80%',
          height: '80%',
        },
      },
      dragToClose: false,
      animated: true,
      showClass: 'fancybox-fadeIn',
      hideClass: 'fancybox-fadeOut',
    };

    NativeFancybox.bind(delegate, opts);

    return () => {
      NativeFancybox.unbind(delegate);
      NativeFancybox.close();
    };
  }, [delegate, options]);

  return <>{children}</>;
}
